import React, { useState, useRef, useEffect } from 'react';

function LanguageDropdown() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('ENGLISH');
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const languages = [
    { code: 'EN', label: 'ENGLISH' },
    { code: 'SK', label: 'SLOVENSKÝ' },
    { code: 'CS', label: 'ČEŠKÝ' },
  ];

  function onSelect(lang) {
    setSelected(lang.label);
    setOpen(false);
  }

  return (
    <li className="dropdown" ref={dropdownRef} style={{ position: 'relative' }}>
      <button
        id="lang"
        onClick={() => setOpen(!open)}
        className="dropdown-toggle nav-group-right-link"
        aria-haspopup="true"
        aria-expanded={open}
        type="button"
      >
        {selected} <i className="fa-solid fa-globe"></i>
      </button>

      {open && (
        <ul className="dropdown-menu">
          {languages.map((lang) => (
            <li
              key={lang.code}
              onClick={() => onSelect(lang)}
              className={`dropdown-item ${selected === lang.label ? 'selected' : ''}`}
            >
              {lang.label}
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}

export default LanguageDropdown;
